import { NavLink, Link } from 'react-router-dom';

import { MENU_ITEMS } from '../config';
import { getSlugValue } from '../helpers/urlHelpers';

const Menu = () => {
  return (
    <div className="menu">
      {MENU_ITEMS.map(item => {
        const link = getSlugValue(item.label);
        return (
          <div className="menu-item" key={item.label}>
            <NavLink to={link} activeClassName="active">
              {item.label}
            </NavLink>
            {item.children && (
              <div className="menu-item__children">
                {item.children.map(keyName => (
                  <Link to={link + '#' + keyName} key={keyName}>
                    {keyName}
                  </Link>
                ))}
              </div>
            )}
          </div>
        )
      })}
    </div>
  )
}

export default Menu;
